import CryptoJS from "crypto-js";

const SECRET_KEY_BASE64 = process.env.REACT_APP_SECRET_KEY_BASE64;

if (!SECRET_KEY_BASE64) {
  throw new Error("Missing REACT_APP_SECRET_KEY_BASE64 in .env");
}

const SECRET_KEY = CryptoJS.enc.Base64.parse(SECRET_KEY_BASE64);

export function decryptPayload<T = any>(encryptedBase64?: string): T | null {
  try {
    if (!encryptedBase64) {
      throw new Error("No ciphertext provided");
    }

    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64),
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, SECRET_KEY, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);

    if (!decryptedStr) {
      throw new Error("Decryption failed – empty plaintext");
    }

    return JSON.parse(decryptedStr) as T;
  } catch (err) {
    console.error("Decryption error:", err);
    return null;
  }
}
